import { IconDispatcher } from "shared/ui-basics/index";
import styled from "styled-components/macro";

interface ColorCircleProps {
	color?: string;
}

export const ColorCircle: React.FC<ColorCircleProps> = ({ color = "#ffffff" }) => {
	return <Container color={color}>{IconDispatcher("bookmark")}</Container>;
};

const Container = styled.div<{ color: string }>`
	min-width: 40px;
	min-height: 40px;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	border: 1px solid #262626;
	background-color: ${({ color }) => color};
`;
